import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "input", "item"]

  connect() {
    this.boundHandleClickOutside = this.handleClickOutside.bind(this)
    this.boundHandleKeydown = this.handleKeydown.bind(this)
    document.addEventListener("click", this.boundHandleClickOutside)
    document.addEventListener("keydown", this.boundHandleKeydown)
    this.trigger = this.element.querySelector('[data-action*="filter-pill#toggle"]')
    this.setOpen(false)
  }

  disconnect() {
    document.removeEventListener("click", this.boundHandleClickOutside)
    document.removeEventListener("keydown", this.boundHandleKeydown)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.hasMenuTarget) {
      const isHidden = this.menuTarget.classList.contains("hidden")
      if (isHidden) {
        this.setOpen(true)
        if (this.hasInputTarget) {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              this.inputTarget.focus()
            })
          })
        }
      } else {
        this.setOpen(false)
      }
    }
  }

  filter() {
    if (!this.hasInputTarget) return
    const query = this.inputTarget.value.toLowerCase().trim()

    this.itemTargets.forEach(item => {
      const text = item.textContent.toLowerCase()
      if (query === "" || text.includes(query)) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target) && this.hasMenuTarget) {
      this.setOpen(false)
    }
  }

  handleKeydown(event) {
    if (event.key === "Escape" && this.hasMenuTarget && !this.menuTarget.classList.contains("hidden")) {
      event.preventDefault()
      this.setOpen(false)
      this.trigger?.focus()
    }
  }

  setOpen(open) {
    if (!this.hasMenuTarget) return

    this.menuTarget.classList.toggle("hidden", !open)
    this.trigger?.setAttribute("aria-expanded", open.toString())
  }
}
